/* ============================================================
   Shopify Product Configurator — configurator.js v1.5
   - Galerij-modus (voor upload) ↔ Editor-modus (na upload)
   - Gender picker (Man / Vrouw) als productoptie
   - Alt-tekst conventie: "Kleur Gender Voorkant/Achterkant/Lifestyle 1"
   ============================================================ */

(function () {
  'use strict';

  const LF_NL = (document.documentElement.lang || '').toLowerCase().slice(0,2) === 'nl' || location.pathname.slice(0,3) === '/nl';

  /* ── Tier discounts ──────────────────────────────────────── */

  // 8-tier ladder uit configurator.old.js — staffels van LabelLab
  const TIER_DISCOUNTS = [
    { qty: 15,   factor: 1.000, save: null },
    { qty: 25,   factor: 0.970, save: 3   },
    { qty: 50,   factor: 0.920, save: 8   },
    { qty: 100,  factor: 0.870, save: 13  },
    { qty: 200,  factor: 0.790, save: 21  },
    { qty: 500,  factor: 0.750, save: 25  },
    { qty: 1000, factor: 0.730, save: 27  },
    { qty: 2000, factor: 0.700, save: 30  },
  ];

  // Technique multipliers
  const TECHNIQUES = [
    { id: 'embroidery',      label: LF_NL ? 'Borduren' : 'Embroidery', multiplier: 1.30 },
    { id: 'full-colour',     label: 'Transfer',   multiplier: 1.15 },
    { id: 'screen-printing', label: LF_NL ? 'Zeefdruk' : 'Screen',     multiplier: 1.00 },
    { id: 'dtg',             label: 'DTG',        multiplier: 1.20 },
  ];

  // Maximum printvlak per positie (in cm) — basis voor cm²-berekening.
  // Wordt overschreven door per-product waarden uit custom.print_area_cm metafield.
  const PRINT_AREA_CM_DEFAULT = { width: 36, height: 68 };
  function getPrintAreaCm(placement) {
    const pa = productData && productData.printArea;
    const w  = (pa && pa.width)  || PRINT_AREA_CM_DEFAULT.width;
    const h  = (pa && pa.height) || PRINT_AREA_CM_DEFAULT.height;
    return { width: w, height: h };
  }

  // Print zone als fractie van het canvas (0–1) — gekalibreerd op Stanley/Stella model-foto's (SFM1/SBM0).
  // front: borst t/m buik, vrij van armen. back: volledige rug, vrij van armen.
  const PRINT_ZONE_CANVAS = {
    front: { top: 0.35, bottom: 0.93, left: 0.24, right: 0.76 },
    back:  { top: 0.35, bottom: 0.93, left: 0.24, right: 0.76 },
  };

  // Maatcategorieën op basis van oppervlakte in cm²
  const PRINT_SIZE_TIERS = [
    { label: 'S',  min: 0,   max: 50   },
    { label: 'M',  min: 50,  max: 200  },
    { label: 'L',  min: 200, max: 600  },
    { label: 'XL', min: 600, max: 1200 },
  ];

  // Printprijs per maatcategorie
  const PRINT_TIER_PRICES = {
    'S':   3.50,
    'M':   6.50,
    'L':  10.00,
    'XL': 14.00,
  };
  const BTW_RATE = 0.21;

  const PLACEMENT_LABELS = {
    front: LF_NL ? 'Voor' : 'Front',
    back:  LF_NL ? 'Achter' : 'Back',
  };

  const ALL_PLACEMENTS = ['front', 'back'];

  const COLOR_HEX_MAP = {
    'black':'#111111','zwart':'#111111',
    'white':'#f8f8f8','wit':'#f8f8f8',
    'khaki':'#c2a97a','cream':'#f5f0e8','crème':'#f5f0e8',
    'navy':'#1a2744','dark navy':'#1a2744','donkerblauw':'#1a2744','marine':'#1c2e5e',
    'grey':'#9ca3af','gray':'#9ca3af','grijs':'#9ca3af',
    'light grey':'#d1d5db','lichtgrijs':'#d1d5db',
    'red':'#dc2626','rood':'#dc2626',
    'blue':'#2563eb','blauw':'#2563eb',
    'green':'#16a34a','groen':'#16a34a',
    'yellow':'#eab308','geel':'#eab308',
    'orange':'#ea580c','oranje':'#ea580c',
    'pink':'#ec4899','roze':'#ec4899',
    'purple':'#7c3aed','paars':'#7c3aed',
    'brown':'#92400e','bruin':'#92400e',
    'beige':'#d4b896','sand':'#e8d5b0','zand':'#e8d5b0',
    'olive':'#6b7c3e','olijf':'#6b7c3e',
    'burgundy':'#800020','bordeaux':'#800020',
    'camel':'#c19a6b',
    // Jouw product kleuren
    'earthy raw':   '#8B7355',
    'desert beige': '#B58A5A',
    'deep navy':    '#1F223A',
    'muted olive':  '#6B7A3E',
    'cloud grey':   '#B0AEA8',
  };

  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const ACCEPTED_TYPES = ['.eps','.ai','.pdf','.png','.jpg','.jpeg'];

  /* ── Product data ────────────────────────────────────────── */

  const productData = window.__productData || null;
  const isDemoMode  = !productData;

  /* ── State ───────────────────────────────────────────────── */

  const state = {
    colorValue:        null,
    gender:            null,   // bijv. 'Man' of 'Vrouw'
    placement:         'front',
    technique:         'screen-printing',
    quantity:          25,
    selectedTierIndex: 1,
    useCustomQty:      false,
    designs:      { front: [], back: [] },
    activeDesign: null,
    dragging:     false,
    resizing:     false,
    rotating:     false,
    dragStart:    null,
    editMode:     false,  // false = galerij, true = canvas editor
    galleryIndex: 0,
  };

  /* ── Derived ─────────────────────────────────────────────── */

  function getColorOption() {
    if (!productData) return null;
    const names = ['color','colour','kleur','farbe'];
    return productData.options.find(o => names.includes(o.name.toLowerCase()))
      || productData.options[0] || null;
  }

  function getGenderOption() {
    if (!productData) return null;
    const names = ['gender','geslacht','fit','type'];
    return productData.options.find(o => names.includes(o.name.toLowerCase())) || null;
  }

  function getSelectedVariant() {
    if (!productData) return null;
    const colorOpt  = getColorOption();
    const genderOpt = getGenderOption();
    let filtered = productData.variants;

    if (colorOpt && state.colorValue) {
      const key = 'option' + colorOpt.position;
      filtered = filtered.filter(v => v[key] === state.colorValue);
    }
    if (genderOpt && state.gender) {
      const key = 'option' + genderOpt.position;
      filtered = filtered.filter(v => v[key] === state.gender);
    }
    return filtered[0] || productData.variants[0];
  }

  function getImageForPlacement(placement) {
    if (!productData) return null;
    const colorVal = state.colorValue || '';

    // 1. Filenaam-based: images getagged met placement (PFM/SFM=front, PBM/SBM=back)
    const byColorList = (productData.imagesByColor && productData.imagesByColor[colorVal]) || null;
    if (byColorList && byColorList.length) {
      const hit = byColorList.find(img => img.placement === placement);
      if (hit) return hit.src;
      // Geen back-foto voor deze kleur → val terug op front voor deze kleur
      if (placement === 'back') {
        const front = byColorList.find(img => img.placement === 'front');
        if (front) return front.src;
      }
      return byColorList[0]?.src || null;
    }

    // 2. Fallback: alle images (oude alt-tekst matching, voor niet-LabelLab products)
    const images      = productData.images || [];
    const colorLower  = colorVal.toLowerCase();
    const genderLower = (state.gender || '').toLowerCase();
    const frontTerms  = ['front', 'voorkant', 'voor'];
    const backTerms   = ['back',  'achterkant', 'achter'];
    const terms       = placement === 'front' ? frontTerms : backTerms;

    const byPlacementField = images.find(img =>
      img.placement === placement && (!colorLower || (img.color || '').toLowerCase() === colorLower)
    );
    if (byPlacementField) return byPlacementField.src;

    if (genderLower) {
      const hit = images.find(img => {
        const alt = img.alt || '';
        return terms.some(t => alt.toLowerCase().includes(t))
          && alt.toLowerCase().includes(colorLower)
          && altHasWord(alt, genderLower);
      });
      if (hit) return hit.src;
    }
    const byColor = images.find(img => {
      const alt = (img.alt || '').toLowerCase();
      return terms.some(t => alt.includes(t)) && alt.includes(colorLower);
    });
    if (byColor) return byColor.src;

    const byPlacement = images.find(img => {
      const alt = (img.alt || '').toLowerCase();
      return terms.some(t => alt.includes(t));
    });
    if (byPlacement) return byPlacement.src;

    return getSelectedVariant()?.image || null;
  }

  // Controleer of een woord exact voorkomt in alt-tekst (voorkomt "men" matchen in "women")
  function altHasWord(alt, word) {
    return alt.toLowerCase().split(/\s+/).includes(word.toLowerCase());
  }

  // Gender-woorden in alt-teksten (voor detectie neutrale foto's)
  const GENDER_WORDS = ['men', 'man', 'women', 'woman', 'vrouw'];

  // Geeft alle galerij-foto's terug gefilterd op kleur + gender
  function getGalleryImages() {
    if (isDemoMode) {
      // Demo: placeholder slides zonder echte URL
      return [
        { id: 'demo-1', alt: LF_NL ? 'Voor' : 'Front',  src: null },
        { id: 'demo-2', alt: LF_NL ? 'Achter' : 'Back',   src: null },
        { id: 'demo-3', alt: 'Detail', src: null },
      ];
    }
    const colorVal = state.colorValue || '';
    // Voorkeur: imagesByColor[colorname] (gefilterd op SKU color code)
    const byColorList = (productData.imagesByColor && productData.imagesByColor[colorVal]) || null;
    if (byColorList && byColorList.length) {
      return byColorList.filter(img => img.src);
    }

    const images      = productData.images || [];
    const colorLower  = colorVal.toLowerCase();
    const genderLower = (state.gender || '').toLowerCase();

    const hasRealImages = images.some(img => img.src);

    let filtered = images.filter(img => {
      if (hasRealImages && !img.src) return false;
      // Kleurfilter via expliciet color veld of via alt
      if (colorLower) {
        const imgColor = (img.color || '').toLowerCase();
        const alt = (img.alt || '').toLowerCase();
        if (imgColor) {
          if (imgColor !== colorLower) return false;
        } else if (!alt.includes(colorLower)) {
          return false;
        }
      }
      const alt = img.alt || '';
      if (genderLower) {
        const hasGenderTag = GENDER_WORDS.some(g => altHasWord(alt, g));
        if (hasGenderTag && !altHasWord(alt, genderLower)) return false;
      }
      return true;
    });

    // Fallback: kleur only
    if (filtered.length === 0 && genderLower) {
      filtered = images.filter(img => {
        if (hasRealImages && !img.src) return false;
        const alt = img.alt || '';
        return !colorLower || alt.toLowerCase().includes(colorLower);
      });
    }

    // Fallback: alles
    if (filtered.length === 0) {
      filtered = hasRealImages ? images.filter(img => img.src) : images;
    }

    return filtered;
  }

  function hasAnyUpload() {
    return ALL_PLACEMENTS.some(pl => state.designs[pl].length > 0);
  }

  function getColorHex(name) {
    if (productData) {
      const opt = getColorOption();
      if (opt?.swatches) {
        const hex = opt.swatches[name];
        if (hex) return hex.startsWith('#') ? hex : '#' + hex;
      }
    }
    return COLOR_HEX_MAP[name?.toLowerCase()] || '#cccccc';
  }

  function getTechMultiplier() {
    return TECHNIQUES.find(t => t.id === state.technique)?.multiplier || 1.0;
  }

  // Tel het aantal "spot"-kleuren in een geüploade afbeelding.
  // Tekent de afbeelding klein, kwantiseert de kleuren en telt alleen
  // de clusters die genoeg voorkomen (anti-aliasing/JPEG-ruis eruit).
  // Witte/transparante achtergrond wordt genegeerd. Begrensd op 1–6.
  function countColors(img) {
    try {
      if (!img || !img.naturalWidth) return 1;
      const N = 72;
      const r = img.naturalWidth / img.naturalHeight || 1;
      let w = N, h = N;
      if (r >= 1) h = Math.max(1, Math.round(N / r));
      else        w = Math.max(1, Math.round(N * r));
      const oc = document.createElement('canvas');
      oc.width = w; oc.height = h;
      const c = oc.getContext('2d', { willReadFrequently: true });
      c.imageSmoothingEnabled = false;                        // nearest → geen nieuwe mengkleuren langs randen
      c.drawImage(img, 0, 0, w, h);
      const data = c.getImageData(0, 0, w, h).data;
      const counts = {};
      let total = 0;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 32) continue;                       // transparant
        const R = data[i], G = data[i + 1], B = data[i + 2];
        if (R > 240 && G > 240 && B > 240) continue;          // (bijna) witte achtergrond
        const key = (R >> 6) + ',' + (G >> 6) + ',' + (B >> 6); // buckets van 64
        counts[key] = (counts[key] || 0) + 1;
        total++;
      }
      if (total === 0) return 1;
      const thresh = Math.max(1, total * 0.03);               // negeer kleuren <3% (anti-aliasing/ruis)
      const n = Object.values(counts).filter(v => v >= thresh).length;
      return Math.min(8, Math.max(1, n));                     // ruw aantal (cap 8) — >4 = te veel voor zeefdruk
    } catch (e) { return 1; }
  }

  // Aantal kleuren voor zeefdruk-prijs = som van de gedetecteerde kleuren over
  // alle uploads (elk design eigen zeven), per design begrensd op 4 (zeefdruk-max).
  // Geen upload → 1 (minimum €75).
  function getScreenColors() {
    let sum = 0;
    ALL_PLACEMENTS.forEach(pl => {
      state.designs[pl].forEach(d => { sum += Math.min(4, d.colorCount || 1); });
    });
    return Math.max(1, sum);
  }

  // Heeft een geüpload design méér dan 4 kleuren? Dan is zeefdruk niet geschikt
  // → klant moet DTG kiezen of contact opnemen.
  function screenHasTooManyColours() {
    if (state.technique !== 'screen-printing') return false;
    return ALL_PLACEMENTS.some(pl => state.designs[pl].some(d => (d.colorCount || 1) > 4));
  }

  // Eenmalige opstart-/setupkosten per techniek (geen prijs-per-stuk).
  //  • Zeefdruk (screen-printing): 1 kleur = €75, daarna €50 per kleur (2=€100, 3=€150, 4=€200…)
  //  • Borduren (embroidery): €50 vast, ongeacht aantal
  //  • DTF (full-colour/Transfer) + DTG: geen opstartkosten
  function getSetupCost() {
    if (state.technique === 'embroidery') return 50;
    if (state.technique === 'screen-printing') {
      const c = getScreenColors();
      return c <= 1 ? 75 : c * 50;
    }
    return 0;
  }

  function getTierEntry(qty) {
    let e = TIER_DISCOUNTS[0];
    for (let i = TIER_DISCOUNTS.length - 1; i >= 0; i--) {
      if (qty >= TIER_DISCOUNTS[i].qty) { e = TIER_DISCOUNTS[i]; break; }
    }
    return e;
  }

  // Bereken canvas-rechthoek van de print zone op basis van vaste canvas-fracties.
  function getZoneCanvasRect(placement) {
    if (canvasCssW === 0 || canvasCssH === 0) return null;
    const zone = PRINT_ZONE_CANVAS[placement] || PRINT_ZONE_CANVAS.front;
    return {
      x: zone.left  * canvasCssW,
      y: zone.top   * canvasCssH,
      w: (zone.right  - zone.left) * canvasCssW,
      h: (zone.bottom - zone.top)  * canvasCssH,
    };
  }

  // Bereken de actuele breedte en hoogte van een design in cm
  // op basis van de huidige scale t.o.v. de print zone (niet het volledige canvas).
  function getDesignDimensionsInCm(design, placement) {
    if (!design.img || canvasCssW === 0 || canvasCssH === 0) return null;
    const t   = design.transform;
    const ir  = (design.img.naturalWidth / design.img.naturalHeight) || 1;
    const bs  = Math.min(canvasCssW, canvasCssH) * 0.28 * t.scale;
    const dw_px = ir >= 1 ? bs : bs * ir;
    const dh_px = ir >= 1 ? bs / ir : bs;
    const zone  = getZoneCanvasRect(placement);
    const zoneW = zone ? zone.w : canvasCssW;
    const zoneH = zone ? zone.h : canvasCssH;
    const area  = getPrintAreaCm(placement);
    return {
      width_cm:  (dw_px / zoneW)  * area.width,
      height_cm: (dh_px / zoneH) * area.height,
    };
  }

  // Bereken de oppervlakte in cm², begrensd op het maximale printvlak
  function getDesignAreaCm2(design, placement) {
    const dims = getDesignDimensionsInCm(design, placement);
    if (!dims) return 0;
    const area    = getPrintAreaCm(placement);
    const maxArea = area.width * area.height;
    return Math.min(dims.width_cm * dims.height_cm, maxArea);
  }

  // Geeft de maatcategorie (S/M/L/XL) terug op basis van cm²
  function getPrintTier(areaCm2) {
    if (areaCm2 <= 0) return null;
    for (const tier of PRINT_SIZE_TIERS) {
      if (areaCm2 <= tier.max) return tier.label;
    }
    return 'XL'; // veilige fallback voor > 1200 cm² (kan door clamping niet voorkomen)
  }

  // Geeft de printprijs terug op basis van de maatcategorie
  function getPrintPriceAddByTier(tier) {
    return PRINT_TIER_PRICES[tier] || 0;
  }

  function getPrintPriceAdd() {
    let total = 0;
    ALL_PLACEMENTS.forEach(pl => {
      state.designs[pl].forEach(d => {
        const area = getDesignAreaCm2(d, pl);
        const tier = getPrintTier(area);
        if (tier) total += getPrintPriceAddByTier(tier);
      });
    });
    return total;
  }

  function getBaseVariantPrice() {
    if (isDemoMode) return 15.61;
    return getSelectedVariant()?.price || 0;
  }

  function calcPrice(qty) {
    const base  = getBaseVariantPrice() + getPrintPriceAdd();
    const mult  = getTechMultiplier();
    const tier  = getTierEntry(qty);
    const unit  = +(base * mult * tier.factor).toFixed(2);
    const setup = getSetupCost();                       // eenmalig
    const total = +(unit * qty + setup).toFixed(2);     // setup telt één keer mee
    return { unit, total, setup, save: tier.save };
  }

  function fmt(n) {
    return '€\u202f' + n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getSizeLabel() {
    const parts = [];
    ALL_PLACEMENTS.forEach(pl => {
      state.designs[pl].forEach(d => {
        const area = getDesignAreaCm2(d, pl);
        const tier = getPrintTier(area);
        if (tier) parts.push(`${PLACEMENT_LABELS[pl]}: ${tier}`);
      });
    });
    return parts.length ? parts.join(' · ') : null;
  }

  /* ── Gallery ─────────────────────────────────────────────── */

  function setEditMode(on) {
    state.editMode = on;
    const galleryEl = document.getElementById('image-gallery');
    const editorEl  = document.getElementById('image-editor');
    if (galleryEl) galleryEl.style.display = on ? 'none' : '';
    if (editorEl) {
      editorEl.classList.toggle('active', on);
      editorEl.style.display = on ? 'block' : 'none';
    }
    if (on) {
      const imgUrl = getImageForPlacement(state.placement);
      loadVariantImage(imgUrl || null);
      resizeCanvas();
    } else {
      state.galleryIndex = 0;
      updateGallery();
    }
  }

  function updateGallery() {
    const images = getGalleryImages();

    // Clamp index
    if (state.galleryIndex >= images.length && images.length > 0) {
      state.galleryIndex = images.length - 1;
    }

    const imgEl       = document.getElementById('gallery-main-img');
    const placeholder = document.getElementById('gallery-color-placeholder');
    const labelEl     = document.getElementById('gallery-placeholder-label');
    const dotsEl      = document.getElementById('gallery-dots');
    const prevBtn     = document.getElementById('gallery-prev');
    const nextBtn     = document.getElementById('gallery-next');

    const current = images[state.galleryIndex] || null;

    // Beeld of placeholder
    if (current?.src) {
      if (imgEl) {
        imgEl.src = current.src;
        imgEl.alt = current.alt || '';
        imgEl.classList.add('visible');
      }
      if (placeholder) placeholder.style.display = 'none';
    } else {
      if (imgEl) imgEl.classList.remove('visible');
      const hex = state.colorValue ? getColorHex(state.colorValue) : '#c8c5c0';
      if (placeholder) {
        placeholder.style.display = '';
        placeholder.style.background = hex;
      }
      if (labelEl) labelEl.textContent = current?.alt || '';
    }

    // Thumbnails
    const thumbStrip = document.getElementById('thumb-strip');
    if (thumbStrip) {
      thumbStrip.innerHTML = '';
      images.forEach((img, i) => {
        const thumb = document.createElement('img');
        thumb.className = 'thumb-item' + (i === state.galleryIndex ? ' active' : '');
        thumb.src = img.src || '';
        thumb.alt = img.alt || '';
        thumb.addEventListener('click', () => { state.galleryIndex = i; updateGallery(); });
        thumbStrip.appendChild(thumb);
      });
    }

    // Pijlen
    if (prevBtn) prevBtn.style.display = images.length > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = images.length > 1 ? '' : 'none';

    // Prototype-extras (counter, color-tag, dots, label) — wrapped to never break gallery
    try {
      const counter = document.getElementById('gallery-counter');
      if (counter) {
        const cur = String((state.galleryIndex || 0) + 1).padStart(2, '0');
        const tot = String(Math.max(images.length, 1)).padStart(2, '0');
        counter.textContent = cur + ' / ' + tot;
      }
      const tag = document.getElementById('gallery-color-tag');
      if (tag && state.colorValue) tag.textContent = state.colorValue;

      const dotsHost = document.querySelector('.gal-foot .dots');
      if (dotsHost && images && images.length) {
        dotsHost.innerHTML = '';
        images.forEach((_, i) => {
          const d = document.createElement('span');
          d.className = 'dot' + (i === state.galleryIndex ? ' cur' : '');
          d.addEventListener('click', () => { state.galleryIndex = i; updateGallery(); });
          dotsHost.appendChild(d);
        });
      }

      const labelEl = document.querySelector('.gal-foot .label');
      if (labelEl && current) {
        if (current.placement === 'back') labelEl.textContent = LF_NL ? 'Achter' : 'Back';
        else if (current.placement === 'detail') labelEl.textContent = 'Detail';
        else labelEl.textContent = LF_NL ? 'Voor' : 'Front';
      }
    } catch (e) {
      console.warn('[configurator] gallery extras failed:', e);
    }
  }

  /* ── Canvas ──────────────────────────────────────────────── */

  let canvas, ctx, canvasCssW = 0, canvasCssH = 0;

  function rotatePoint(px, py, cx, cy, angle) {
    const cos = Math.cos(angle), sin = Math.sin(angle);
    const dx = px - cx, dy = py - cy;
    return { x: cx + dx*cos - dy*sin, y: cy + dx*sin + dy*cos };
  }

  function setGarmentImage(url) {
    const el = document.getElementById('garment-img');
    if (!el) return;
    if (url) { el.src = url; el.style.display = ''; }
    else      { el.removeAttribute('src'); el.style.display = 'none'; }
  }

  function drawHandle(x, y, fillColor, strokeColor, symbol) {
    ctx.fillStyle = fillColor;
    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.arc(x, y, 7, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = strokeColor;
    ctx.font = 'bold 9px sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(symbol, x, y + 0.5);
  }

  function drawSingleDesign(design, isActive) {
    if (!design.img || !design.img.complete) return;
    const t   = design.transform;
    const w   = canvasCssW, h = canvasCssH;
    const bs  = Math.min(w, h) * 0.28 * t.scale;
    const ir  = design.img.naturalWidth / design.img.naturalHeight || 1;
    const dw  = ir >= 1 ? bs : bs * ir;
    const dh  = ir >= 1 ? bs / ir : bs;
    const cx  = t.x * w;
    const cy  = t.y * h;
    const rot = t.rotation || 0;

    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(rot);
    ctx.globalAlpha = 0.92;
    ctx.drawImage(design.img, -dw/2, -dh/2, dw, dh);
    ctx.globalAlpha = 1;

    if (isActive) {
      ctx.strokeStyle = '#3b82f6';
      ctx.lineWidth = 1.5;
      ctx.setLineDash([5, 4]);
      ctx.strokeRect(-dw/2 - 4, -dh/2 - 4, dw + 8, dh + 8);
      ctx.setLineDash([]);

      drawHandle( dw/2 + 4,  dh/2 + 4, '#3b82f6', '#fff', '⤡');
      drawHandle(-dw/2 - 4,  dh/2 + 4, '#fff', '#555',    '↻');
      drawHandle( dw/2 + 4, -dh/2 - 4, '#ef4444', '#fff', '✕');
    } else {
      ctx.strokeStyle = 'rgba(150,150,150,0.45)';
      ctx.lineWidth = 1;
      ctx.setLineDash([4, 3]);
      ctx.strokeRect(-dw/2 - 4, -dh/2 - 4, dw + 8, dh + 8);
      ctx.setLineDash([]);
    }

    ctx.restore();
    design._bounds = { cx, cy, dw, dh, rot };
  }

  function drawPrintZone(placement) {
    const r = getZoneCanvasRect(placement);
    if (!r || r.w <= 0 || r.h <= 0) return;
    ctx.save();
    ctx.strokeStyle = 'rgba(80, 130, 220, 0.35)';
    ctx.lineWidth   = 1;
    ctx.setLineDash([5, 5]);
    ctx.strokeRect(r.x, r.y, r.w, r.h);
    ctx.setLineDash([]);
    ctx.font      = '10px sans-serif';
    ctx.fillStyle = 'rgba(80, 130, 220, 0.45)';
    ctx.textAlign = 'left';
    ctx.fillText(LF_NL ? 'Printgebied' : 'Print area', r.x + 5, r.y + 13);
    ctx.restore();
  }

  function drawDesignOverlay() {
    state.designs[state.placement].forEach(d =>
      drawSingleDesign(d, d === state.activeDesign));
  }

  function render() {
    ctx.clearRect(0, 0, canvasCssW, canvasCssH);
    // Print-area stippelkader bewust NIET tekenen (kaderde niet goed) — drawPrintZone uitgezet.
    drawDesignOverlay();
  }

  function resizeCanvas() {
    if (!canvas) return;
    const wrap = canvas.parentElement;
    const dpr  = window.devicePixelRatio || 1;
    canvasCssW = wrap.clientWidth;
    canvasCssH = wrap.clientHeight;
    canvas.width  = Math.round(canvasCssW * dpr);
    canvas.height = Math.round(canvasCssH * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    render();
  }

  function loadVariantImage(url) {
    setGarmentImage(url || null);
    render();
  }

  /* ── Canvas interactions ─────────────────────────────────── */

  function canvasXY(e) {
    const rect = canvas.getBoundingClientRect();
    const ex = e.touches ? e.touches[0].clientX : e.clientX;
    const ey = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: (ex - rect.left) * (canvasCssW / rect.width),
      y: (ey - rect.top)  * (canvasCssH / rect.height),
    };
  }

  function localPos(pos, d) {
    if (!d?._bounds) return null;
    const { cx, cy, rot } = d._bounds;
    const p = rotatePoint(pos.x, pos.y, cx, cy, -(rot || 0));
    return { x: p.x - cx, y: p.y - cy };
  }

  function isOnHandle(pos, d, type) {
    const lp = localPos(pos, d);
    if (!lp) return false;
    const { dw, dh } = d._bounds;
    if (type === 'resize') return Math.hypot(lp.x - ( dw/2+4), lp.y - ( dh/2+4)) < 14;
    if (type === 'rotate') return Math.hypot(lp.x - (-dw/2-4), lp.y - ( dh/2+4)) < 14;
    if (type === 'delete') return Math.hypot(lp.x - ( dw/2+4), lp.y - (-dh/2-4)) < 14;
    return false;
  }

  function isOnDesign(pos, d) {
    const lp = localPos(pos, d);
    if (!lp) return false;
    const { dw, dh } = d._bounds;
    return lp.x >= -dw/2-4 && lp.x <= dw/2+4 && lp.y >= -dh/2-4 && lp.y <= dh/2+4;
  }

  function removeDesign(d, placement) {
    const arr = state.designs[placement];
    const idx = arr.indexOf(d);
    if (idx !== -1) arr.splice(idx, 1);
    d._listItem?.remove();
    if (state.activeDesign === d) {
      state.activeDesign = arr.length ? arr[arr.length - 1] : null;
    }
    render(); updateSetupUI(); updatePricingTable(); updateStickyBar();
    // Terug naar galerij als alle uploads weg zijn
    if (!hasAnyUpload()) setEditMode(false);
  }

  function onPointerDown(e) {
    const pos     = canvasXY(e);
    const designs = state.designs[state.placement];

    if (state.activeDesign) {
      if (isOnHandle(pos, state.activeDesign, 'delete')) {
        removeDesign(state.activeDesign, state.placement);
        e.preventDefault(); return;
      }
      if (isOnHandle(pos, state.activeDesign, 'resize')) {
        state.resizing  = true;
        state.dragStart = { ...pos, scale: state.activeDesign.transform.scale };
        e.preventDefault(); return;
      }
      if (isOnHandle(pos, state.activeDesign, 'rotate')) {
        state.rotating = true;
        const t  = state.activeDesign.transform;
        const cx = t.x * canvasCssW;
        const cy = t.y * canvasCssH;
        state.dragStart = {
          startAngle:    Math.atan2(pos.y - cy, pos.x - cx),
          startRotation: t.rotation || 0,
        };
        e.preventDefault(); return;
      }
    }

    for (let i = designs.length - 1; i >= 0; i--) {
      if (isOnDesign(pos, designs[i])) {
        state.activeDesign = designs[i];
        state.dragging     = true;
        state.dragStart    = {
          mx: pos.x, my: pos.y,
          tx: designs[i].transform.x,
          ty: designs[i].transform.y,
        };
        canvas.style.cursor = 'grabbing';
        render();
        e.preventDefault(); return;
      }
    }

    state.activeDesign = null;
    render();
  }

  function onPointerMove(e) {
    if (!state.dragging && !state.resizing && !state.rotating) return;
    const pos = canvasXY(e);
    const d   = state.activeDesign;
    if (!d) return;
    const t = d.transform;

    if (state.dragging) {
      t.x = Math.max(0.05, Math.min(0.95, state.dragStart.tx + (pos.x - state.dragStart.mx) / canvasCssW));
      t.y = Math.max(0.05, Math.min(0.95, state.dragStart.ty + (pos.y - state.dragStart.my) / canvasCssH));
    }

    if (state.resizing) {
      const base = Math.min(canvasCssW, canvasCssH) * 0.28;
      const dist = Math.hypot(pos.x - t.x*canvasCssW, pos.y - t.y*canvasCssH);
      t.scale = Math.max(0.2, Math.min(3.0, dist / (base * 0.5)));
    }

    if (state.rotating) {
      const cx = t.x * canvasCssW;
      const cy = t.y * canvasCssH;
      t.rotation = state.dragStart.startRotation +
        (Math.atan2(pos.y - cy, pos.x - cx) - state.dragStart.startAngle);
    }

    render();
    updatePricingTable();
    updateStickyBar();
    e.preventDefault();
  }

  function onPointerUp() {
    state.dragging = false;
    state.resizing = false;
    state.rotating = false;
    canvas.style.cursor = 'default';
  }

  /* ── Gender picker ───────────────────────────────────────── */

  // Detecteer gender-waarden uit product opties OF uit alt-teksten van foto's
  function detectGenderValues() {
    // 1. Uit product optie (bijv. "Gender: Man / Vrouw")
    const opt = getGenderOption();
    if (opt) return opt.values;

    // 2. Uit alt-teksten van foto's (unisex product met getagde foto's)
    if (productData?.images) {
      const found = [];
      const checks = ['man', 'vrouw', 'women', 'woman', 'men'];
      productData.images.forEach(img => {
        const words = (img.alt || '').toLowerCase().split(/\s+/);
        checks.forEach(g => {
          if (words.includes(g)) {
            // Gebruik originele hoofdletters uit eerste match
            const orig = (img.alt || '').split(/\s+/).find(w => w.toLowerCase() === g);
            const label = orig
              ? orig.charAt(0).toUpperCase() + orig.slice(1).toLowerCase()
              : g.charAt(0).toUpperCase() + g.slice(1);
            if (!found.includes(label)) found.push(label);
          }
        });
      });
      if (found.length > 0) return found;
    }

    return [];
  }

  function buildGenderPicker(container) {
    const wrapper = document.getElementById('gender-picker');
    const values  = isDemoMode ? ['Man', 'Vrouw'] : detectGenderValues();

    if (values.length === 0) {
      if (wrapper) wrapper.style.display = 'none';
      return;
    }

    if (wrapper) wrapper.style.display = '';

    container.innerHTML = '';
    values.forEach(v => {
      const btn = document.createElement('button');
      btn.className = 'gender-pill' + (v === state.gender ? ' cur active' : '');
      btn.textContent = v;
      btn.addEventListener('click', () => {
        // Klik op actieve knop = deselecteer
        state.gender = state.gender === v ? null : v;
        document.querySelectorAll('.gender-pill').forEach(el => el.classList.remove('cur', 'active'));
        if (state.gender) btn.classList.add('cur', 'active');
        if (!state.editMode) {
          state.galleryIndex = 0;
          updateGallery();
        } else {
          const imgUrl = getImageForPlacement(state.placement);
          if (imgUrl) loadVariantImage(imgUrl);
        }
        updatePricingTable();
        updateStickyBar();
      });
      container.appendChild(btn);
    });
  }

  /* ── Swatches ────────────────────────────────────────────── */

  function buildSwatches(container) {
    container.innerHTML = '';
    let colors = [];

    if (isDemoMode) {
      colors = [
        { value: 'Black', hex: '#111111' },
        { value: 'Grey',  hex: '#9ca3af' },
        { value: 'White', hex: '#f5f5f5' },
      ];
      if (!state.colorValue) state.colorValue = colors[0].value;
    } else {
      const opt = getColorOption();
      if (!opt) return;
      if (!state.colorValue) state.colorValue = opt.values[0];
      colors = opt.values.map(v => ({ value: v, hex: getColorHex(v) }));
    }

    colors.forEach(c => {
      const isActive = c.value === state.colorValue;
      const item = document.createElement('div');
      item.className = 'sw swatch-item' + (isActive ? ' active' : '');
      // Swatch image uit Liquid-gegenereerde swatches map (PFM0 per kleur)
      const swatchSrc = productData?.swatches?.[c.value] || null;
      const imgEl = swatchSrc
        ? `<img src="${swatchSrc}" alt="${c.value}">`
        : `<span class="tee" style="display:block;width:100%;height:100%;background:${c.hex};"></span>`;
      item.innerHTML = `<div class="sw-img swatch-circle${isActive ? ' cur' : ''}">${imgEl}</div><span class="sw-name swatch-label">${c.value}</span>`;
      item.addEventListener('click', () => {
        state.colorValue = c.value;
        document.querySelectorAll('.sw-img').forEach(el => el.classList.remove('cur'));
        document.querySelectorAll('.swatch-item').forEach(el => el.classList.remove('active'));
        item.classList.add('active');
        item.querySelector('.sw-img')?.classList.add('cur');

        const colorNameEl = document.getElementById('current-color-name');
        if (colorNameEl) colorNameEl.textContent = c.value;
        const galTagEl = document.getElementById('gallery-color-tag');
        if (galTagEl) galTagEl.textContent = c.value;

        if (!state.editMode) {
          state.galleryIndex = 0;
          updateGallery();
        } else {
          const imgUrl = getImageForPlacement(state.placement);
          if (imgUrl) loadVariantImage(imgUrl);
          else loadVariantImage(null);
        }
        updatePricingTable();
        updateStickyBar();
      });
      container.appendChild(item);
    });

    // Initieel beeld laden
    if (!state.editMode) {
      updateGallery();
    } else if (!isDemoMode) {
      const imgUrl = getImageForPlacement(state.placement);
      if (imgUrl) loadVariantImage(imgUrl);
      else {
        const v = getSelectedVariant();
        if (v?.image) loadVariantImage(v.image);
      }
    }
  }

  /* ── Technique pills ─────────────────────────────────────── */

  function buildTechniquePills(container) {
    container.innerHTML = '';
    TECHNIQUES.forEach(t => {
      const isActive = t.id === state.technique;
      const btn = document.createElement('button');
      btn.className = 'tech technique-pill' + (isActive ? ' cur active' : '');
      btn.dataset.technique = t.id;
      btn.type = 'button';
      btn.textContent = t.label;
      btn.addEventListener('click', () => {
        state.technique = t.id;
        document.querySelectorAll('.technique-pill').forEach(el => el.classList.remove('cur', 'active'));
        btn.classList.add('cur', 'active');
        updateSetupUI();
        updatePricingTable();
        updateStickyBar();
        document.dispatchEvent(new CustomEvent('labellab:technique-changed', { detail: { technique: t.id } }));
      });
      container.appendChild(btn);
    });
  }

  /* ── Pricing table ───────────────────────────────────────── */

  function buildPricingTable(container) {
    container.innerHTML = '';
    const head = document.createElement('div');
    head.className = 'qty-head';
    head.innerHTML = `<span>${LF_NL?'Stuks':'Pieces'}</span><span class="right">${LF_NL?'Per stuk':'Per unit'}</span><span class="right">${LF_NL?'Korting':'Saving'}</span><span class="right">${LF_NL?'Totaal':'Total'}</span>`;
    container.appendChild(head);

    const currentQty = state.useCustomQty ? state.quantity : TIER_DISCOUNTS[state.selectedTierIndex].qty;
    const activeTierIdx = getTierIndexForQty(currentQty);

    TIER_DISCOUNTS.forEach((tier, i) => {
      const { unit, save } = calcPrice(tier.qty);
      const next = TIER_DISCOUNTS[i + 1];
      const tierMax = tier.max != null ? tier.max : (next ? next.qty - 1 : 9999);
      const range = next ? `${tier.qty}–${tierMax}` : `${tier.qty}+`;
      const rowQty = (state.useCustomQty && i === activeTierIdx) ? currentQty : tier.qty;
      // Tabel toont product-subtotaal (zonder setup); setup staat los eronder.
      const rowTotal = +(unit * rowQty).toFixed(2);
      const isActive = i === activeTierIdx;
      const row = document.createElement('div');
      row.className = 'qty-row' + (isActive ? ' cur active' : '');
      row.dataset.tierIndex = i;
      row.dataset.min = tier.qty;
      row.dataset.max = tierMax;
      row.dataset.unit = unit;
      row.dataset.save = save || 0;
      row.innerHTML = `<span>${range}</span><span>${fmt(unit)}</span><span>${save ? `−${save}%` : '—'}</span><span>${fmt(rowTotal)}</span>`;
      row.addEventListener('click', () => {
        state.selectedTierIndex = i;
        state.quantity     = tier.qty;
        state.useCustomQty = false;
        const qi = document.getElementById('qty-input');
        if (qi) qi.value = tier.qty;
        buildPricingTable(container);
        updateStickyBar();
        updateCustomQtyDisplay();
        updateQtyMeta();
      });
      container.appendChild(row);
    });
  }

  function getTierIndexForQty(qty) {
    let idx = 0;
    for (let i = TIER_DISCOUNTS.length - 1; i >= 0; i--) {
      if (qty >= TIER_DISCOUNTS[i].qty) { idx = i; break; }
    }
    return idx;
  }

  function updateQtyMeta() {
    const qty = state.useCustomQty ? state.quantity : TIER_DISCOUNTS[state.selectedTierIndex].qty;
    const tierIdx = getTierIndexForQty(qty);
    const tier = TIER_DISCOUNTS[tierIdx];
    const next = TIER_DISCOUNTS[tierIdx + 1];

    // Optional legacy element (mag weg zijn na rebuild)
    const labelEl = document.getElementById('qty-tier-label');
    const tierMax = tier.max != null ? tier.max : (next ? next.qty - 1 : 9999);
    const range = next ? `${tier.qty}–${tierMax}` : `${tier.qty}+`;
    if (labelEl) labelEl.textContent = `${range} pcs`;

    const { unit, total } = calcPrice(qty);

    // Legacy "qty-summary" + "total-per" zijn weg in de POLISH-final layout — guarded.
    const sumEl = document.getElementById('qty-summary');
    if (sumEl) sumEl.textContent = `${qty} ${LF_NL?'st':'pcs'} · ${fmt(unit)}/${LF_NL?'stuk':'unit'}`;
    const tPer = document.getElementById('total-per');
    if (tPer) tPer.textContent = `${fmt(unit)}/${LF_NL?'stuk':'unit'} · ${qty} ${LF_NL?'st':'pcs'}`;

    // Bind beide "Add N to reach -X%" links (legacy foot + nieuwe top)
    const nextLink    = document.getElementById('qty-next-link');
    const nextLinkTop = document.getElementById('qty-next-link-top');
    [nextLink, nextLinkTop].forEach(el => {
      if (!el) return;
      if (next) {
        const remain = next.qty - qty;
        el.textContent = `${LF_NL?'Voeg':'Add'} ${remain} ${LF_NL?'toe voor':'to reach'} −${next.save}%`;
        el.dataset.targetQty = next.qty;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.removeAttribute('data-target-qty');
        el.style.display = 'none';
      }
    });

    const tAmt = document.getElementById('total-amt');
    if (tAmt) tAmt.textContent = fmt(total);
  }

  function updatePricingTable() {
    const el = document.getElementById('pricing-table');
    if (el) buildPricingTable(el);
  }

  // Korte techniek-omschrijving onder de knoppen (beweegt mee met de keuze).
  const TECH_NOTES = {
    'screen-printing': (LF_NL ? 'Zeefdruk · steunkleur · scherpe randen · tot 4 kleuren' : 'Screen print · solid colour · sharp edges · up to 4 colours'),
    'embroidery':      'Embroidery · stitched finish · durable · best for logos & text',
    'full-colour':     (LF_NL ? 'Transfer · full colour · fotografisch detail · geen kleurlimiet' : 'Transfer · full colour · photographic detail · no colour limit'),
    'dtg':             (LF_NL ? 'Direct-to-garment · full colour · geen kleurlimiet · zachte afwerking' : 'Direct-to-garment · full colour · no colour limit · soft finish'),
  };

  // Werkt de techniek-note, de opstart-hint en de opstart-regel bij.
  // Aantal kleuren wordt automatisch uit de upload bepaald.
  function updateSetupUI() {
    const isScreen = state.technique === 'screen-printing';
    const setup    = getSetupCost();
    const tooMany  = screenHasTooManyColours();

    // 1. Techniek-omschrijving meebewegen
    const note = document.getElementById('tech-note');
    if (note) note.textContent = TECH_NOTES[state.technique] || '';

    // 2. Opstart-/waarschuwingshint
    const hint = document.getElementById('setup-hint');
    if (hint) {
      hint.classList.remove('warn');
      if (isScreen && tooMany) {
        hint.textContent = (LF_NL ? 'Meer dan 4 kleuren gedetecteerd — niet geschikt voor zeefdruk. Kies DTG voor full colour, of neem contact op.' : 'More than 4 colours detected — not suitable for screen print. Choose DTG for full colour, or contact us.');
        hint.classList.add('warn');
        hint.style.display = '';
      } else if (setup > 0 && isScreen) {
        const n = getScreenColors();
        hint.textContent = hasAnyUpload()
          ? `${LF_NL?'Zeefdruk':'Screen print'} · ${n} ${LF_NL?'kleur':'colour'}${n === 1 ? '' : (LF_NL?'en':'s')} ${LF_NL?'gedetecteerd':'detected'} · setup ${fmt(setup)} — ${LF_NL?'eenmalig':'one-time'}`
          : `${LF_NL?'Zeefdruk-setup vanaf':'Screen print setup from'} ${fmt(setup)} — ${LF_NL?'eenmalig':'one-time'} · ${LF_NL?'op basis van je artwork-kleuren':'based on your artwork colours'}`;
        hint.style.display = '';
      } else if (setup > 0) {
        hint.textContent = `${LF_NL?'Borduur-setup':'Embroidery setup'}: ${fmt(setup)} — ${LF_NL?'eenmalig':'one-time'}`;
        hint.style.display = '';
      } else {
        hint.style.display = 'none';
      }
    }

    // 3. Opstart-regel bij de prijs
    const line = document.getElementById('setup-cost-line');
    const amt  = document.getElementById('setup-cost-amt');
    if (line) line.style.display = setup > 0 ? '' : 'none';
    if (amt)  amt.textContent = fmt(setup);
  }

  function updateStickyBar() {
    const qty = state.useCustomQty ? state.quantity : TIER_DISCOUNTS[state.selectedTierIndex].qty;
    const { total, unit } = calcPrice(qty);
    const te = document.getElementById('sticky-total');
    const ue = document.getElementById('sticky-unit');
    if (ue) ue.textContent = `${fmt(unit)}/${LF_NL?'stuk':'unit'}`;
    if (te) {
      te.textContent = fmt(total);
      te.removeAttribute('href');
    }
    updateQtyMeta();
  }

  function updateCustomQtyDisplay() {
    const el = document.getElementById('custom-qty-display');
    if (!el) return;
    if (state.useCustomQty && state.quantity >= 15) {
      const { unit, total } = calcPrice(state.quantity);
      el.classList.add('visible');
      el.querySelector('.cqv').textContent = fmt(total);
      el.querySelector('.cqu').textContent = `${fmt(unit)} ${LF_NL?'per stuk':'per unit'} · ${state.quantity} ${LF_NL?'st':'pcs'}`;
    } else {
      el.classList.remove('visible');
    }
  }

  /* ── File handling ───────────────────────────────────────── */

  function handleFile(file, placement) {
    if (!file) return;
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!ACCEPTED_TYPES.includes(ext)) { showToast('File type not supported.'); return; }
    if (file.size > MAX_FILE_SIZE)      { showToast('File too large. Max 10 MB.'); return; }

    const reader = new FileReader();
    reader.onload = e => {
      const dataUrl = e.target.result;
      const extUp   = ext.replace('.','').toUpperCase();
      const design  = {
        name:      file.name,
        size:      file.size,
        ext:       extUp,
        img:       new Image(),
        _bounds:   null,
        _listItem: null,
        transform: { x: 0.50, y: 0.38, scale: 0.6, rotation: 0 },
      };

      if (['.png','.jpg','.jpeg'].includes(ext)) {
        design.img.onload = () => { design.colorCount = countColors(design.img); render(); updateSetupUI(); updatePricingTable(); updateStickyBar(); };
        design.img.src = dataUrl;
      } else if (['.ai','.pdf'].includes(ext) && typeof pdfjsLib !== 'undefined') {
        // Render eerste pagina via PDF.js (werkt voor .ai en .pdf)
        const typedArr = new Uint8Array(e.target.result);
        pdfjsLib.getDocument({ data: typedArr }).promise.then(pdf => {
          pdf.getPage(1).then(page => {
            const viewport = page.getViewport({ scale: 2 });
            const oc  = document.createElement('canvas');
            oc.width  = viewport.width;
            oc.height = viewport.height;
            page.render({ canvasContext: oc.getContext('2d'), viewport }).promise.then(() => {
              design.img = new Image();
              design.img.onload = () => { design.colorCount = countColors(design.img); render(); updateSetupUI(); updatePricingTable(); updateStickyBar(); };
              design.img.src = oc.toDataURL();
            });
          });
        }).catch(() => {
          design.img = makeVectorPlaceholder(extUp);
          render(); updatePricingTable(); updateStickyBar();
          showToast(`Could not render preview — your ${extUp} file has been added and will be processed by our team.`, 5000);
        });
      } else {
        design.img = makeVectorPlaceholder(extUp);
        render(); updatePricingTable(); updateStickyBar();
      }

      state.designs[placement].push(design);
      state.activeDesign = design;
      addFileToList(design, placement);

      // Schakel naar editor-modus bij eerste upload
      if (!state.editMode) setEditMode(true);

      const input = document.getElementById(`file-input-${placement}`);
      if (input) input.value = '';
    };
    if (['.ai','.pdf'].includes(ext) && typeof pdfjsLib !== 'undefined') {
      reader.readAsArrayBuffer(file);
    } else {
      reader.readAsDataURL(file);
    }
  }

  function makeVectorPlaceholder(ext) {
    const oc = document.createElement('canvas');
    oc.width = oc.height = 200;
    const c = oc.getContext('2d');
    c.fillStyle = '#e8e8e8'; c.fillRect(0,0,200,200);
    c.fillStyle = '#555'; c.font = 'bold 36px Inter, sans-serif';
    c.textAlign = 'center'; c.textBaseline = 'middle';
    c.fillText(ext, 100, 100);
    const img = new Image(); img.src = oc.toDataURL(); return img;
  }

  function addFileToList(design, placement) {
    const list = document.getElementById(`file-list-${placement}`);
    if (!list) return;

    const item = document.createElement('div');
    item.className = 'file-preview visible';
    item.innerHTML = `
      <div class="file-icon">${design.ext}</div>
      <span class="file-name">${design.name}</span>
      <span class="file-size">${fmtBytes(design.size)}</span>
      <button class="file-remove" title="Verwijderen">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>`;

    item.querySelector('.file-remove').addEventListener('click', () => {
      removeDesign(design, placement);
    });

    item.addEventListener('click', e => {
      if (e.target.closest('.file-remove')) return;
      state.activeDesign = design;
      render();
    });

    design._listItem = item;
    list.appendChild(item);
  }

  function fmtBytes(b) {
    if (b < 1024) return b+' B';
    if (b < 1048576) return (b/1024).toFixed(1)+' KB';
    return (b/1048576).toFixed(1)+' MB';
  }

  function uploadAreaHTML(pl) {
    return `
      <div class="dropzone" id="dropzone-${pl}">
        <input type="file" id="file-input-${pl}" accept=".eps,.ai,.pdf,.png,.jpg,.jpeg" />
        <svg class="dropzone-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
        </svg>
        <p class="dropzone-text">Drag or <strong>click to upload</strong></p>
        <p class="dropzone-subtext">EPS · AI · PDF · PNG · JPG &nbsp;·&nbsp; Max 10 MB</p>
      </div>
      <div class="file-list" id="file-list-${pl}"></div>`;
  }

  /* ── Print helpers ───────────────────────────────────────── */

  function calcPrintSize(design, placement) {
    const dims = getDesignDimensionsInCm(design, placement || state.placement);
    if (!dims) return '— cm';
    const area = getDesignAreaCm2(design, placement || state.placement);
    const tier = getPrintTier(area);
    return `${dims.width_cm.toFixed(1)} × ${dims.height_cm.toFixed(1)} cm (${tier || '—'})`;
  }

  function calcPrintPosition(x, y) {
    const xLabel = x < 0.38 ? 'Left' : x > 0.62 ? 'Right' : 'Centered';
    const yLabel = y < 0.35 ? 'High (shoulder)' : y < 0.55 ? 'Chest' : y < 0.72 ? 'Middle' : 'Low';
    return `${xLabel}, ${yLabel}`;
  }

  /* ── Toast ───────────────────────────────────────────────── */

  function showToast(msg, duration = 3000) {
    const t = document.getElementById('configurator-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), duration);
  }

  /* ── Cart ────────────────────────────────────────────────── */

  async function addToCart() {
    const qiEl = document.getElementById('qty-input');
    const inputQty = qiEl ? parseInt(qiEl.value, 10) : NaN;
    const qty = !isNaN(inputQty) && inputQty >= 15
      ? inputQty
      : (state.useCustomQty ? state.quantity : TIER_DISCOUNTS[state.selectedTierIndex].qty);
    if (qty < 15) { showToast(LF_NL ? 'Minimaal 15 stuks.' : 'Minimum 15 pieces.'); return; }
    const variant = getSelectedVariant();
    const tech    = TECHNIQUES.find(t => t.id === state.technique);
    const { unit, total, setup } = calcPrice(qty);

    const placements = ALL_PLACEMENTS
      .filter(pl => state.designs[pl].length > 0)
      .map(pl => PLACEMENT_LABELS[pl]);

    const unitBtw      = +(unit  * BTW_RATE).toFixed(2);
    const unitInclBtw  = +(unit  * (1 + BTW_RATE)).toFixed(2);
    const totalBtw     = +(total * BTW_RATE).toFixed(2);
    const totalInclBtw = +(total * (1 + BTW_RATE)).toFixed(2);

    const printAdd = getPrintPriceAdd();
    const tierIdx  = getTierIndexForQty(qty);
    const tierObj  = TIER_DISCOUNTS[tierIdx];
    const tierMax  = tierObj.max != null ? tierObj.max : (TIER_DISCOUNTS[tierIdx + 1] ? TIER_DISCOUNTS[tierIdx + 1].qty - 1 : 9999);
    const tierLabel = tierIdx === TIER_DISCOUNTS.length - 1 ? `${tierObj.qty}+` : `${tierObj.qty}–${tierMax}`;

    const properties = {
      [LF_NL ? 'Totaal excl. btw' : 'Total excl. VAT']:          fmt(total),
      'VAT 21%':                  fmt(totalBtw),
      [LF_NL ? 'Totaal incl. btw' : 'Total incl. VAT']:          fmt(totalInclBtw),
      '_Color':                   state.colorValue || '—',
      '_Gender':                  state.gender || '—',
      '_Placement':               placements.length ? placements.join(' + ') : '—',
      '_Print zone':              getSizeLabel() || '—',
      '_Technique':               tech?.label || '—',
      '_Quantity':                qty,
      '_Unit price excl. VAT':    fmt(unit),
      '_Print add':               printAdd,
      // Eenmalige opstart-/setupkosten (zeefdruk/borduren) — al inbegrepen in _Subtotal.
      '_Setup':                   setup.toFixed(2),
      // ANTWOORDEN-3-vragen §2 — voor Cart Transform Function
      '_Tier':                    `${tierIdx}:${tierLabel}`,
      '_Unit_price':              unit.toFixed(2),
      '_Subtotal':                total.toFixed(2),
    };

    if (setup > 0) {
      properties[LF_NL ? 'Opstartkosten (eenmalig)' : 'Setup cost (one-time)'] = fmt(setup);
      if (state.technique === 'screen-printing') properties['_Screen colors'] = getScreenColors();
    }
    if (screenHasTooManyColours()) {
      properties['_Colour warning'] = 'Screen print artwork has >4 colours — confirm DTG or contact customer';
    }

    ALL_PLACEMENTS.forEach(pl => {
      const label = PLACEMENT_LABELS[pl].toLowerCase();
      state.designs[pl].forEach((d, i) => {
        const num = state.designs[pl].length > 1 ? ` ${i+1}` : '';
        const rot = Math.round((d.transform.rotation || 0) * 180 / Math.PI);
        properties[`_File ${label}${num}`]     = d.name;
        properties[`_Size ${label}${num}`]     = calcPrintSize(d, pl);
        properties[`_Position ${label}${num}`] = calcPrintPosition(d.transform.x, d.transform.y);
        if (rot !== 0) properties[`_Rotation ${label}${num}`] = rot + '°';
      });
    });

    if (window.Shopify && variant) {
      const btn = document.getElementById('add-to-cart-btn');
      btn.textContent = 'Processing…'; btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: qty, properties }),
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        // Update cart teller zonder pagina refresh
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const count = cartData.item_count;
        // Savor's built-in cart bubble (if present)
        document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(el => {
          el.textContent = count;
          el.classList.remove('hidden');
        });
        document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(el => {
          el.classList.remove('visually-hidden');
        });
        // LabelLab header badges — update if exist, otherwise create
        document.querySelectorAll('a[aria-label="Cart"]').forEach(link => {
          const isDesktop = link.id === 'cart-icon-bubble';
          let badge = link.querySelector(isDesktop ? '.ll-h-cart-badge' : '.badge');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = isDesktop ? 'll-h-cart-badge' : 'badge';
              link.appendChild(badge);
            }
            badge.textContent = count;
            badge.style.display = '';
          } else if (badge) {
            badge.remove();
          }
        });
        showToast(LF_NL ? 'Toegevoegd!' : 'Added to cart!');
      } catch (err) {
        showToast('Error: ' + err.message);
      } finally {
        btn.textContent = LF_NL ? 'In winkelwagen' : 'Add to cart'; btn.disabled = false;
      }
    } else {
      console.log('[Configurator] Cart payload:', { variantId: variant?.id, qty, properties });
      showToast('Cart payload logged (demo mode)');
    }
  }

  /* ── Build HTML ──────────────────────────────────────────── */

  function buildHTML(root) {
    const title = productData?.title || 'Product configurator';
    root.innerHTML = `
      <div class="configurator-wrapper">

        <!-- Links: beeld -->
        <div class="image-panel">

          <!-- Thumbnail strip -->
          <div class="thumb-strip" id="thumb-strip"></div>

          <!-- Galerij-modus (standaard) -->
          <div id="image-gallery" class="image-gallery">
            <div class="gallery-img-wrap">
              <img id="gallery-main-img" class="gallery-main-img" alt="" />
              <div id="gallery-color-placeholder" class="gallery-color-placeholder">
                <span id="gallery-placeholder-label" class="gallery-placeholder-label"></span>
              </div>
            </div>
            <button class="gallery-arrow gallery-prev" id="gallery-prev" aria-label="Vorige">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </button>
            <button class="gallery-arrow gallery-next" id="gallery-next" aria-label="Volgende">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </button>
          </div>

          <!-- Editor-modus (na upload) -->
          <div id="image-editor" class="image-editor" style="display:none">
            <button class="gallery-back-btn" id="gallery-back-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              Photos
            </button>
            <div class="image-canvas-wrap">
              <img id="garment-img" class="garment-img" alt="" />
              <canvas id="preview-canvas"></canvas>
              <div class="preview-side-tabs">
                <button class="preview-side-tab active" data-placement="front">Front</button>
                <button class="preview-side-tab" data-placement="back">Back</button>
              </div>
            </div>
          </div>

        </div>

        <!-- Rechts: configuratie -->
        <div class="config-panel">
          <h1 class="product-title">${title}</h1>
          ${productData?.shortDescription ? `<p class="product-subtitle">${productData.shortDescription}</p>` : ''}

          <!-- 1. Productvariant (gender + kleur) -->
          <div class="cfg-section">
            <div class="cfg-section-title">
              <span class="cfg-number">1</span>
              Pick a product variant
            </div>

            <div id="gender-picker" style="display:none">
              <p class="field-label">Gender</p>
              <div class="gender-pills" id="gender-pills"></div>
            </div>

            <p class="field-label" style="margin-top:16px">Color</p>
            <div class="color-swatches" id="color-swatches"></div>
          </div>

          <!-- 2. Design -->
          <div class="cfg-section">
            <div class="cfg-section-title">
              <span class="cfg-number">2</span>
              Upload your design
            </div>

            <div class="placement-tabs">
              <button class="placement-btn active" data-placement="front">Front</button>
              <button class="placement-btn" data-placement="back">Back</button>
            </div>

            <p class="field-label">Printing technique</p>
            <div class="technique-pills" id="technique-pills"></div>

            <p class="setup-hint" id="setup-hint" style="display:none"></p>

            <div id="upload-area-front">${uploadAreaHTML('front')}</div>
            <div id="upload-area-back" style="display:none">${uploadAreaHTML('back')}</div>
          </div>

          <!-- 3. Quantity & Price -->
          <div class="cfg-section cfg-section-last">
            <div class="cfg-section-title">
              <span class="cfg-number">3</span>
              Quantity &amp; Price
            </div>

            <div class="qty-row">
              <label for="qty-input">Quantity:</label>
              <input type="number" id="qty-input" class="qty-input" value="25" min="15" max="99999" />
              <span class="qty-hint">min. 15</span>
            </div>

            <div id="pricing-table"></div>

            <div class="setup-cost-line" id="setup-cost-line" style="display:none">
              <span>Setup cost (one-time)</span>
              <span class="setup-cost-amt" id="setup-cost-amt">—</span>
            </div>

            <div class="custom-qty-display" id="custom-qty-display">
              <div class="cql">Your price estimate</div>
              <div class="cqv"></div>
              <div class="cqu"></div>
            </div>
          </div>

          <!-- Sticky bar -->
          <div class="sticky-bar">
            <div class="sticky-bar-inner">
              <div class="sticky-leadtime">
                <strong>8–14 business days</strong>
                Estimated delivery
              </div>
              <div class="sticky-price">
                <div class="sticky-price-label">Total excl. VAT</div>
                <div class="sticky-price-value" id="sticky-total">—</div>
                <div class="sticky-price-unit"  id="sticky-unit"></div>
              </div>
              <button class="add-to-cart-btn" id="add-to-cart-btn">Add to cart</button>
            </div>
          </div>

        </div>
      </div>

      <div class="toast" id="configurator-toast"></div>`;
  }

  /* ── Wire events ─────────────────────────────────────────── */

  function wireEvents() {
    // Pijltjes: toon links/rechts op basis van cursor positie
    const gallery = document.querySelector('.image-gallery');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');

    if (gallery && prevBtn && nextBtn) {
      gallery.addEventListener('mousemove', (e) => {
        const { left, width } = gallery.getBoundingClientRect();
        const isLeft = (e.clientX - left) < width / 2;
        prevBtn.classList.toggle('arrow-visible', isLeft);
        nextBtn.classList.toggle('arrow-visible', !isLeft);
      });
      gallery.addEventListener('mouseleave', () => {
        prevBtn.classList.remove('arrow-visible');
        nextBtn.classList.remove('arrow-visible');
      });
    }

    // Galerij navigatie
    document.getElementById('gallery-prev')?.addEventListener('click', (e) => {
      e.preventDefault();
      const imgs = getGalleryImages();
      state.galleryIndex = (state.galleryIndex - 1 + imgs.length) % imgs.length;
      updateGallery();
    });
    document.getElementById('gallery-next')?.addEventListener('click', (e) => {
      e.preventDefault();
      const imgs = getGalleryImages();
      state.galleryIndex = (state.galleryIndex + 1) % imgs.length;
      updateGallery();
    });

    // Terugknop naar galerij
    document.getElementById('gallery-back-btn')?.addEventListener('click', () => {
      setEditMode(false);
    });

    // Plaatsing tabs (image panel + config panel)
    document.querySelectorAll('.preview-side-tab, .placement-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const p = btn.dataset.placement;
        state.placement = p;
        const designs = state.designs[p];
        state.activeDesign = designs.length ? designs[designs.length - 1] : null;

        document.querySelectorAll('.preview-side-tab').forEach(b => {
          const on = b.dataset.placement === p;
          b.classList.toggle('active', on);
          b.classList.toggle('cur', on);
        });
        document.querySelectorAll('.placement-btn').forEach(b => {
          const on = b.dataset.placement === p;
          b.classList.toggle('active', on);
          b.classList.toggle('cur', on);
        });

        ALL_PLACEMENTS.forEach(pl => {
          const el = document.getElementById(`upload-area-${pl}`);
          if (el) el.style.display = pl === p ? 'block' : 'none';
        });

        if (state.editMode) {
          const imgUrl = getImageForPlacement(p);
          if (imgUrl) loadVariantImage(imgUrl);
          else loadVariantImage(null);
        } else {
          // Gallery mode: scroll to the matching front/back image
          const frontTerms = ['front', 'voorkant', 'voor'];
          const backTerms  = ['back',  'achterkant', 'achter'];
          const terms      = p === 'front' ? frontTerms : backTerms;
          const galleryImgs = getGalleryImages();
          const idx = galleryImgs.findIndex(img =>
            terms.some(t => (img.alt || '').toLowerCase().includes(t))
          );
          if (idx !== -1) state.galleryIndex = idx;
          updateGallery();
        }

        updatePricingTable();
        updateStickyBar();
      });
    });

    // Bestandsinput & dropzones
    ALL_PLACEMENTS.forEach(pl => {
      const input = document.getElementById(`file-input-${pl}`);
      const dz    = document.getElementById(`dropzone-${pl}`);
      input?.addEventListener('change', e => handleFile(e.target.files[0], pl));
      // Klik op dropzone (of zijn kinderen, behalve de input zelf) opent file picker
      dz?.addEventListener('click', e => {
        if (e.target === input) return;
        input?.click();
      });
      dz?.addEventListener('dragover',  e => { e.preventDefault(); dz.classList.add('drag-over'); });
      dz?.addEventListener('dragleave', () => dz.classList.remove('drag-over'));
      dz?.addEventListener('drop', e => { e.preventDefault(); dz.classList.remove('drag-over'); handleFile(e.dataTransfer.files[0], pl); });
    });

    // Aantal — input + minus/plus buttons
    const qi = document.getElementById('qty-input');
    function applyQty(v) {
      if (isNaN(v) || v < 15) v = 15;
      if (v > 9999) v = 9999;
      state.quantity = v;
      const ti = TIER_DISCOUNTS.findIndex(t => t.qty === v);
      if (ti !== -1) { state.selectedTierIndex = ti; state.useCustomQty = false; }
      else            { state.useCustomQty = true; state.selectedTierIndex = getTierIndexForQty(v); }
      if (qi) qi.value = v;
      updatePricingTable();
      updateStickyBar();
      updateCustomQtyDisplay();
    }
    // Tijdens typen: alleen tabel updaten als waarde geldig is. Niet clampen / niet de input herschrijven.
    qi?.addEventListener('input', () => {
      const v = parseInt(qi.value, 10);
      if (isNaN(v) || v < 15 || v > 9999) return;
      state.quantity = v;
      const ti = TIER_DISCOUNTS.findIndex(t => t.qty === v);
      if (ti !== -1) { state.selectedTierIndex = ti; state.useCustomQty = false; }
      else            { state.useCustomQty = true; state.selectedTierIndex = getTierIndexForQty(v); }
      updatePricingTable();
      updateStickyBar();
      updateCustomQtyDisplay();
    });
    // Op focus weg / Enter: pas clamping toe en herschrijf de input.
    qi?.addEventListener('blur', () => {
      const v = parseInt(qi.value, 10);
      applyQty(isNaN(v) ? 15 : v);
    });
    qi?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); qi.blur(); }
    });
    document.getElementById('qty-minus')?.addEventListener('click', () => {
      const v = parseInt(qi?.value, 10) || 15;
      applyQty(v - 1);
    });
    document.getElementById('qty-plus')?.addEventListener('click', () => {
      const v = parseInt(qi?.value, 10) || 15;
      applyQty(v + 1);
    });
    ['qty-next-link', 'qty-next-link-top'].forEach(id => {
      document.getElementById(id)?.addEventListener('click', (e) => {
        e.preventDefault();
        const t = parseInt(e.currentTarget.dataset.targetQty, 10);
        if (!isNaN(t)) applyQty(t);
      });
    });

    // Canvas
    canvas.addEventListener('mousedown',  onPointerDown);
    canvas.addEventListener('mousemove',  onPointerMove);
    canvas.addEventListener('mouseup',    onPointerUp);
    canvas.addEventListener('mouseleave', onPointerUp);
    canvas.addEventListener('touchstart', onPointerDown, { passive: false });
    canvas.addEventListener('touchmove',  onPointerMove, { passive: false });
    canvas.addEventListener('touchend',   onPointerUp);

    // Winkelwagen
    document.getElementById('add-to-cart-btn')?.addEventListener('click', addToCart);

    window.addEventListener('resize', () => {
      if (state.editMode) resizeCanvas();
    });
  }

  /* ── Init ────────────────────────────────────────────────── */

  function init(sel) {
    const root = document.querySelector(sel || '#shopify-configurator');
    if (!root) { console.error('[Configurator] Root not found'); return; }
    // If the section already pre-rendered a .configurator-wrapper (Liquid section), skip buildHTML.
    if (!root.querySelector('.configurator-wrapper')) {
      buildHTML(root);
    }
    canvas = document.getElementById('preview-canvas');
    ctx    = canvas.getContext('2d');
    buildGenderPicker(document.getElementById('gender-pills'));
    buildSwatches(document.getElementById('color-swatches'));
    buildTechniquePills(document.getElementById('technique-pills'));
    updateSetupUI();
    buildPricingTable(document.getElementById('pricing-table'));
    updateStickyBar();
    wireEvents();
    updateGallery(); // start in galerij-modus
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  window.ShopifyConfigurator = { init };

})();
